export const UPDATE_RECOMMENDER = 'UPDATE_RECOMMENDER' as const;
export const UPDATE_CODE = 'UPDATE_CODE' as const;
export const UPDATE_EMAIL = 'UPDATE_EMAIL' as const;
